import { observable } from "mobx";
import { Type } from "class-transformer";
import VehicleRegisterSynchronizationStatus from "./vehicleRegisterSynchronizationStatus";
import VehicleRegisterVehicleIdentificationResponse from "./vehicleRegisterVehicleIdentificationResponse";
import VehicleRegistrationChangeChargeResponse from "./vehicleRegistrationChangeChargeResponse";
import VehicleRegistrationChangeExemptionResponse from "./vehicleRegistrationChangeExemptionResponse";
import VehicleRegistrationChangeRejectionReason from "./vehicleRegistrationChangeRejectionReason";
import type VehicleRegistrationChangeWarningReason from "./vehicleRegistrationChangeWarningReason";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class VehicleRegistrationChangePreviewResponse {
  /**
   * If true - change can be submitted.
   */
  @observable
  canBeSubmitted!: boolean;

  /**
   * Changed country ID.
   */
  @observable
  countryId!: string;

  /**
   * Changed license plate.
   */
  @observable
  licensePlate!: string;

  /**
   * Official record ID.
   */
  @observable
  officialRecordId!: string;

  /**
   * Submission date.
   */
  @observable
  @Type(() => Date)
  submissionDate!: Date;

  @observable
  newVehicleRegisterSynchronizationStatus!: VehicleRegisterSynchronizationStatus;

  @observable
  @Type(() => VehicleRegisterVehicleIdentificationResponse)
  newVehicleRegisterVehicle?: VehicleRegisterVehicleIdentificationResponse;

  /**
   * Charges for possible vehicle registration change.
   */
  @observable
  @Type(() => VehicleRegistrationChangeChargeResponse)
  charges!: VehicleRegistrationChangeChargeResponse[];

  /**
   * Exemptions for possible vehicle registration change.
   */
  @observable
  @Type(() => VehicleRegistrationChangeExemptionResponse)
  exemptions!: VehicleRegistrationChangeExemptionResponse[];

  @observable
  rejectionReason?: VehicleRegistrationChangeRejectionReason;

  /**
   * Warning reasons.
   */
  @observable
  warningReasons!: VehicleRegistrationChangeWarningReason[];
}
